import { useMemo } from 'react';

import { useSpace } from '../modules/admin/utils.tsx';
import { Customizations } from './types.ts';

// load all customizations from the "customizations" directory
const customizationModules: any = import.meta.glob('./*/index.tsx', { eager: true });

const useCustomizations = () => {
    const { name: spaceName } = useSpace();

    return useMemo(() => {
        if (!spaceName) return {};

        const modulePath = `./${spaceName}/index.tsx`;
        const customizationModule = customizationModules[modulePath]?.default as Customizations | undefined;

        if (customizationModule) {
            return customizationModule;
        }
    }, [spaceName]);
};

export const useCustomization = <T,>(key: string, fallback: T): T => {
    const customizations = useCustomizations();
    return (customizations as any)?.[key] ?? fallback;
};
